import React, { useState } from 'react';
import { Loader, Loader2, Sparkle } from 'lucide-react';
import WelcomeHero from '../components/WelcomeHero';

import VoicesPanel from '../components/VoicesPanel';
import TrendingTools from 'features/files/components/common/TrendingTools';
import { Button } from 'components/ui/button';
import toast from 'react-hot-toast';
import { ttsService } from '../services/textToSpeechApi';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { VoicePanelMobile } from '../components/EditTool';
import { useVoices } from '../hooks/useVoices';
import { Apps } from 'constants/global';
import Questions from 'features/bot-builder/components/Common/Questions';

const GetStartedMain = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const { data, isLoading } = useVoices();

  const [selectedName, setSelectedName] = useState('');
  const navigate = useNavigate();
  const handleAssignVoices = () => {
    setCurrentStep(2);
  };
  const mutation = useMutation({
    mutationFn: ttsService.generateVoice,
    onSuccess: (data) => {
      localStorage.setItem('audioUrl', data.data);
      localStorage.setItem('text', text);
      localStorage.setItem('selectedName', selectedName);
      navigate(`/text-to-speech/results`);
      setLoading(false);
    },
    onError: (error) => {
      console.error('TTS generation failed:', error);
    },
  });

  const handleConvertToSpeech = async (
    e: React.FormEvent,
    text: string,
    selectedName: string
  ) => {
    e.preventDefault();
    if (text.length < 2) {
      toast.error('Please must be more than 2 characters');
      return;
    }
    if (selectedName === '') {
      toast.error('Please select a voice');
      return;
    }
    setLoading(true);
    mutation.mutate({
      text: text,
      voice_name: selectedName,
      emotion: 'neutral',
      is_celebrity: false,
    });
  };

  return (
    <main className="min-h-screen justify-center items-center bg-background-main dark:bg-background">
      <div className="w-full h-full flex flex-col lg:flex-row justify-center bg-gradient-light dark:bg-gradient-dark bg-no-repeat bg-cover">
        <div className="w-full lg:w-[500px] lg:max-w-[500px] p-4 lg:p-[60px]">
          <WelcomeHero />
        </div>
        <div className="w-full lg:w-3/5 lg:max-w-[800px] p-4 lg:px-[60px] lg:pt-[60px] lg:pb-[72px]">
          <div className="flex sm:flex-row text-text-primary mb-5 gap-4 sm:gap-8">
            <div>
              <p
                className={`text-[14px] font-medium ${currentStep === 1 ? 'text-text-primary' : 'text-text-secondary'}`}
              >
                STEP 1
              </p>
              <h3
                className={`text-[28px] ${currentStep === 1 ? 'text-text-primary font-medium' : 'text-text-secondary'}`}
              >
                Enter Text
              </h3>
            </div>
            <div>
              <p
                className={`text-[14px] ${currentStep === 2 ? 'text-text-primary' : 'text-text-secondary'}`}
              >
                STEP 2
              </p>
              <h3
                className={`text-[28px] ${currentStep === 2 ? 'text-text-primary' : 'text-text-secondary'}`}
              >
                Assign Voices
              </h3>
            </div>
          </div>

          <div className="bg-background rounded-lg p-4 sm:p-10">
            {currentStep === 1 ? (
              <div className="space-y-8">
                <textarea
                  className="w-full h-[250px] bg-background text-text-primary sm:h-[350px] rounded-lg p-4 sm:p-10"
                  placeholder="Click to start typing..."
                  onChange={(e) => setText(e.target.value)}
                  value={text}
                />
                <Button
                  className="bg-primary w-full text-white"
                  onClick={handleAssignVoices}
                  variant="customPrimary"
                >
                  <div className="flex justify-center gap-2 sm:gap-4 text-base sm:text-lg items-center">
                    <Sparkle className="h-5 w-5" />
                    Assign Voices
                  </div>
                </Button>
              </div>
            ) : (
              <div className="">
                <div className="hidden lg:block">
                  <VoicesPanel
                    data={data}
                    selectedName={selectedName}
                    setSelectedName={setSelectedName}
                  />
                </div>
                <div className="block lg:hidden">
                  <VoicePanelMobile
                    data={data}
                    selectedName={selectedName}
                    setSelectedName={setSelectedName}
                  />
                </div>

                <Button
                  className="flex justify-center w-full text-white bg-primary gap-2 sm:gap-4 text-base sm:text-lg items-center"
                  variant="customPrimary"
                  disabled={loading}
                  onClick={(e) => handleConvertToSpeech(e, text, selectedName)}
                >
                  {loading ? (
                    <div className="flex items-center gap-2">
                      <div className="animate-spin">
                        <Loader className="h-5 w-5" />
                      </div>
                      <div className="">Generating Audio</div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      <Sparkle className="h-5 w-5" />
                      Generate Audio
                    </div>
                  )}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Questions appType={Apps.TEXT_TO_SPEECH} />
      {/* <div className="m-3">
        <TrendingTools />
      </div> */}
    </main>
  );
};

export default GetStartedMain;
